var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-overlay",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loadingDialog.open,
          expression: "loadingDialog.open"
        }
      ],
      attrs: {
        color: "#000",
        opacity: "0.40",
        "z-index": _vm.loadingDialog.zIndex
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "text-center mt-n100px card", attrs: { width: "500" } },
        [
          _c("v-progress-circular", {
            staticClass: "mb-20px",
            attrs: { indeterminate: "", color: "primary", size: 25, width: 2 }
          }),
          _c("text-group", {
            attrs: {
              invert: "",
              large: "",
              utext: _vm.loadingDialog.utext,
              btext: _vm.loadingDialog.btext,
              gap: 5
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }